import { action, makeAutoObservable } from 'mobx';
import { DefaultSession } from 'next-auth';
import { ICategory } from '@features/categories/typescript';

class LayoutUiState {
  isSearchOpened = false;

  isPromotionalMessagesOpened = false;

  barPositionStatic = false;

  isMenuDesktopHighlighted = false;

  isMenuMobileOpened = false;

  userPanelOpened = false;

  isLoginGeneralOpened = false;

  isVideoModalOpened = false;

  navigationAndFooterVisible = true;

  isCartCreated = false;

  isSideBarOpened = false;

  navigationProductItemSelected: ICategory | null = null;

  isMenuPined = false;

  navigationCurrentProduct: ICategory | null = null;

  navigationMarketingProduct: ICategory | null = null;

  userData: DefaultSession | boolean = false;

  lastVisitedCategoryId: number | null = null;

  lastVisitedProductId: number | null = null; // TODO: remove this field after fixing product listing pagination

  langPopupHeight: number | null = null;

  isCategoriesFiltersAsideActive = false;

  isProductCardOpened = false;

  navigationContainerIsStatic = true;

  navigationContainerHeight = 100;

  navigationContainerIsVisible = true;

  redirectSearchForm: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  public setNavigationAndFooterVisible = action((value: boolean) => {
    this.navigationAndFooterVisible = value;
  });

  public openSearch = action(() => {
    this.isSearchOpened = true;
    this.setNavigationProductItemSelected(null);
    this.setUserData(false);
    this.isMenuMobileOpened = false;
    this.isMenuPined = false;
  });

  public closeSearch = action(() => {
    this.isSearchOpened = false;
  });

  public setBarsPositionStatic = action((value: boolean) => {
    this.barPositionStatic = value;
  });

  public setIsPromotionalMessagesOpened = action((value: boolean) => {
    this.isPromotionalMessagesOpened = value;
    this.setBarsPositionStatic(!value);
  });

  public setMenuDesktopHighlighted = action((value: boolean) => {
    this.isMenuDesktopHighlighted = value;
  });

  public setMenuMobileOpened = action((value: boolean) => {
    this.isMenuMobileOpened = value;
    this.setMenuPined(false);
    this.setLoginGeneralOpened(false);
  });

  public setUserPanelOpened = action((value: boolean) => {
    this.userPanelOpened = value;
  });

  public setCartCreated = action((value: boolean) => {
    this.isCartCreated = value;
  });

  public setVideoModalOpened = action((value: boolean) => {
    this.isVideoModalOpened = value;
  });

  public setNavigationProductItemSelected = action((product: ICategory | null) => {
    if (this.navigationProductItemSelected?.id !== product?.id) {
      this.navigationProductItemSelected = product;
      this.setMenuPined(true);
    } else {
      this.navigationProductItemSelected = null;
      this.setMenuPined(false);
    }
  });

  public setMenuPined = action((value: boolean) => {
    this.isMenuPined = value;
  });

  public setLoginGeneralOpened = action((value: boolean) => {
    this.isLoginGeneralOpened = value;
  });

  public setNavigationCurrentProduct = action((value: ICategory | null) => {
    this.navigationCurrentProduct = value;
  });

  public setNavigationMarketingProduct = action((value: ICategory | null) => {
    this.navigationMarketingProduct = value;
  });

  public setUserData = action((value: DefaultSession | boolean) => {
    this.userData = value;
  });

  public setIsSideBarOpened = action((value: boolean) => {
    this.isSideBarOpened = value;
  });

  public setIsCategoriesFiltersAsideActive = action((value: boolean) => {
    this.isCategoriesFiltersAsideActive = value;
  });

  public setLastVisitedCategoryId = action((categoryId: number | null) => {
    this.lastVisitedCategoryId = categoryId;
  });

  public setLastVisitedProductId = action((productId: number | null) => {
    this.lastVisitedProductId = productId;
  });

  public setLangPopupHeight = action((height: number) => {
    this.langPopupHeight = height;
  });

  public setIsProductCardOpened = action((value: boolean) => {
    this.isProductCardOpened = value;
  });

  public getLayoutBarsHeight = (): number => {
    let barsHeight = 0;
    if (this.isPromotionalMessagesOpened) barsHeight += 33;
    if (this.langPopupHeight) barsHeight += this.langPopupHeight;
    if (this.navigationContainerIsVisible && !this.navigationContainerIsStatic)
      barsHeight += this.navigationContainerHeight;
    return barsHeight;
  };

  public getLayoutFixedBarsHeight = (): number =>
    !this.barPositionStatic || this.navigationContainerIsVisible ? this.getLayoutBarsHeight() : 0;

  public getLayoutBarsTotalHeight = (): number =>
    this.isPromotionalMessagesOpened ? 33 + 102 + (this.langPopupHeight ?? 0) : 102 + (this.langPopupHeight ?? 0);

  public setNavigationContainerIsStatic = action((value: boolean) => {
    this.navigationContainerIsStatic = value;
  });

  public setNavigationContainerIsVisible = action((value: boolean) => {
    this.navigationContainerIsVisible = value;
  });

  public setNavigationContainerHeight = action((value: number) => {
    this.navigationContainerHeight = value;
  });

  public getRedirectSearchForm = (): string | null => this.redirectSearchForm;

  public setRedirectSearchForm = action((url: string | null) => {
    this.redirectSearchForm = url;
  });
}

export default new LayoutUiState();
